import { IAuthReducer } from "./../../interfaces/auth.interface";
import * as authActions from "../actions/auth/authActions";

const initState: IAuthReducer = {
  user: null,
  fiscalYearList: [],
};

export const authReducer = (state = initState, action: any): IAuthReducer => {
  switch (action.type) {
    case authActions.GET_PROFILE: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case authActions.GET_FISCAL_YEAR: {
      return {
        ...state,
        fiscalYearList: action?.payload || [],
      };
    }
    default: {
      return state;
    }
  }
};
